<template>
    <div
        v-if="true"
        class="product-favorite"
        :class="{
            'product-favorite--active': isFavorite,
            'product-favorite--absolute': absolutePosition,
            'product-favorite--small': small,
        }"
        @click.prevent="changeFavoriteStatus"
    >
        <img src="/nuxt-assets/design2025/icons/heart-secondary-dark-green-2.svg" />
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import { useBasketStore } from '~/stores/basket'
import { GtmEcommerceEventTypeEnum } from '~/models/DataLayer/GtmEcommerceEventTypeEnum'
import FullProduct from '~/models/Product/FullProduct'
import DataLayer from '~/extensions/DataLayer'
import GtmEcommerceEvent from '~/models/DataLayer/GtmEcommerceEvent'
import { useAuthStore } from '~/stores/auth'
import Product from '~/models/Product/Product'
import { transformProductToGtmProduct } from '~/utils/transformProductToGtmProduct'

export default {
    props: {
        product: {
            type: Object as PropType<FullProduct | Product>,
            required: true,
        },
        absolutePosition: {
            type: Boolean,
            default: true,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isFavorite: false,
        }
    },

    computed: {
        authUser(): object | null {
            const basketStore = useBasketStore()

            return basketStore.authUser
        },
    },

    mounted() {
        const basketStore = useBasketStore()
        this.isFavorite = (basketStore.favoriteProductIds || []).includes(this.product.id)
    },

    methods: {
        async changeFavoriteStatus(): Promise<void> {
            const authStore = useAuthStore()
            const accessToken = authStore.accessToken

            if (this.isFavorite) {
                this.isFavorite = false
                await this.$repository.removeFavorite(this.product.id, { accessToken }).then(async () => {
                    await this.reloadUserData()
                })
            } else {
                this.isFavorite = true
                const ecommerceEvent = {
                    type: GtmEcommerceEventTypeEnum.AddToFavorites,
                    products: [transformProductToGtmProduct(this.product)],
                } as GtmEcommerceEvent

                DataLayer.pushEcommerceEventToDataLayer(ecommerceEvent)

                await this.$repository.addFavorite(this.product.id, { accessToken }).then(async () => {
                    await this.reloadUserData()
                })
            }
        },

        async reloadUserData() {
            const basketStore = useBasketStore()
            await basketStore.fetchData()
        },
    },
}
</script>

<style lang="scss" scoped>
$circle-size: 33px;
$heart-size: 19px;
$circle-size-desktop: 44px;
$heart-size-desktop: 24px;

.product-favorite {
    z-index: 1;
    width: $circle-size;
    height: $circle-size;
    border: 1px solid $color-secondary-dark-green-2;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @include screen-md {
        width: $circle-size-desktop;
        height: $circle-size-desktop;
    }

    &:hover {
        background: $color-tercial-light-green-2;
    }

    &--active {
        background: $color-tercial-light-green-2;
    }

    img {
        position: relative;
        top: 1px;
        width: $heart-size;
        height: $heart-size;

        @include screen-md {
            width: $heart-size-desktop;
            height: $heart-size-desktop;
        }
    }

    &--small {
        @include screen-md {
            width: $circle-size;
            height: $circle-size;
        }

        img {
            @include screen-md {
                width: $heart-size;
                height: $heart-size;
            }
        }
    }

    &--absolute {
        position: absolute;
        bottom: 10px;
        left: 0.5em;
    }
}
</style>
